import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils.js';

/* Matches the `INPUT` class string the screens currently inline, so replacing
   one with the other is a no-op visually. */
export function Input({ className, type, ...props }: ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'w-full min-w-0 rounded-(--radius-md) border border-input bg-card',
        'h-(--control-height) px-(--space-3) text-[length:var(--text-body)] text-ink',
        'transition-[border-color,background-color] duration-(--duration-fast) ease-(--ease-out-expo)',
        'placeholder:text-ink-subtle',
        'file:mr-(--space-2) file:border-0 file:bg-transparent file:text-[length:var(--text-small)] file:font-medium',
        'disabled:cursor-not-allowed disabled:bg-muted disabled:text-ink-subtle',
        'aria-invalid:border-danger',
        className,
      )}
      {...props}
    />
  );
}
